var React = require('react');

function Twitch (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"twitch"),React.createElement("g",{"className":"nc-icon-wrapper","fill":"currentColor","key":1},React.createElement("path",{"d":"M5.7 0L1.5 11v44.9h15.3V64h8.6l8.1-8.1h12.4l16.6-16.8V0H5.7zm51.1 36.2l-9.6 9.6H32L23.9 54v-8.1H11V5.7h45.8v30.5zm-9.5-19.5v16.7h-5.7V16.7h5.7zm-15.3 0v16.7h-5.7V16.7H32z"}))]);
}

Twitch.defaultProps = {"version":"1.1","id":"Layer_1","x":"0","y":"0","viewBox":"0 0 64 64","xmlSpace":"preserve","enableBackground":"new 0 0 64 64","width":"64","height":"64"};

module.exports = Twitch;

Twitch.default = Twitch;
